<div class="button"
     (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"
     [ngClass]="{'selected': selected}"
     [wbo-css-var]="{
         '--backColour': colour,
         '--foreColour': foreColour,
         '--buttonFont': font,
         '--buttonFontStyle': fontStyle,
         '--buttonFontSize': fontSize,
         '--buttonFontWeight': fontWeight
     }">

    <div class="button-face">
        <div class="button-face-text" *ngIf="!image" [innerHTML]="text"></div>
        <img class="button-face-img" *ngIf="image" [src]="imageUrl">
        <fui-icon class="button-face-icon" *ngIf="icon" [height]="25" [width]="25" [icon]="icon"></fui-icon>
    </div>

    <div [ngClass]="{'paintingCursor': (model.painting$ | async) && !actionButton, 'pointerCursor': actionButton}" class="button-tool-panel">
        <div *ngIf="showLeftCommandElement" class="button-tool-panel-control left"
             (click)="stopPropagation($event)">
            <div class="button-tool-panel-control-action">
                <div [ngTemplateOutlet]="leftCommands" class="button-tool-panel-control-commands">
                </div>
            </div>
        </div>
        <div *ngIf="showRightCommandElement || showNavigateTo" class="button-tool-panel-control right">
            <div>
                <div *ngIf="showRightCommandElement" class="button-tool-panel-control-action" (click)="stopPropagation($event)">
                    <div [ngTemplateOutlet]="rightCommands" class="button-tool-panel-control-commands">
                    </div>
                </div>
                <div (click)="navigate($event)" *ngIf="showNavigateToElement" class="button-tool-panel-control-action">
                    <fui-commands [showPopupForSingleItems]="true" icon="chevron-right">
                        <fui-command>
                        </fui-command>
                    </fui-commands>
                </div>
            </div>
        </div>
    </div>
</div>
